import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzOffer165 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_65: Record<
  Exclude<PageIdWoofzOffer165, PageIdWoofzOffer165.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzOffer165.SUBSCRIPTIONS_OFFER1_65]: {
    id: PageIdWoofzOffer165.SUBSCRIPTIONS_OFFER1_65,
    hasHeader: false,
  },
  [PageIdWoofzOffer165.CHAT_UPSELL_OFFER1_65]: {
    id: PageIdWoofzOffer165.CHAT_UPSELL_OFFER1_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer165.UPSELL_OFFER1_65]: {
    id: PageIdWoofzOffer165.UPSELL_OFFER1_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer165.DOWNLOAD_OFFER1_65]: {
    id: PageIdWoofzOffer165.DOWNLOAD_OFFER1_65,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
